<template>
    <div class="wrapper pd-b-160 movie-page">
        <MovieCover :data="movieCover"/>
        <HorizontalScrollListCircular :data="movieCastList"/>
        <div class="comments-section mg-t-10">
            <div class="pd-t-20 pd-b-20 pd-l-20 pd-r-20 comments-count bg-solitude cl-black">
                <div v-if="comments.list.length > 0">
                    <div class="dp-fx fx-al-ct">
                        <div class="fz-16 lh-19 fw-7">{{ comments.list.length }}</div>
                        <div class="mg-l-4 fz-14 fw-4 lh-17">{{ getCommentsTitle() }}</div>
                    </div>
                </div>
                <div v-else class="fz-16 fw-7">{{ getCommentsTitle() }}</div>
            </div>
            <PostComment />
            <CommentsList :data="comments" class="pd-b-30"/>
        </div>
        <HorizontalScrollListRectangular :data="similarMoviesList"/>
        <div class="pos-fix bt-init lt-init rt-init">
            <div class="wrapper">
                <div class="bottom-tray movie-page">
                    <div class="pd-t-30 pd-b-20 dp-fx fx-dr-col fx-al-ct">
                        <div class="pd-t-6 pd-b-6 pd-l-16 pd-r-16 br-rd-15 solid-tint-black-black50 cl-white fz-14 lh-20">Is this movie nepotistic?</div>
                        <div class="mg-t-24 dp-fx fx-js-ct fx-al-ct wd-full">
                            <div class="wd-full dp-fx fx-al-ct fx-js-ar">
                                <TwitterShareButton :data="twitterShare"/>
                                <AgainstButton v-on:against-button-clicked="ratingSubmit('nope')" :class="{'bttn-disable' : buttonDisabled}"/>
                                <SupportButton v-on:support-button-clicked="ratingSubmit('like')" :class="{'bttn-disable' : buttonDisabled}"/>
                                <CommentButton v-on:comment-button-clicked="commentButtonClicked"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import axios from "axios";
    import firebase from "firebase";
    import MovieCover from "@/components/MovieCover.vue";
    import HorizontalScrollListCircular from "@/components/HorizontalScrollListCircular.vue";
    import HorizontalScrollListRectangular from "@/components/HorizontalScrollListRectangular.vue";
    import CommentsList from "@/components/CommentsList.vue";
    import PostComment from "@/components/PostComment.vue";
    import TwitterShareButton from "@/components/TwitterShareButton.vue";
    import CommentButton from "@/components/CommentButton.vue";
    import SupportButton from "@/components/SupportButton.vue";
    import AgainstButton from "@/components/AgainstButton.vue";
    import { mapState } from "vuex";

    const fb = require('../firebaseConfig.js');
    const increment = firebase.firestore.FieldValue.increment(1);

    export default {
        name : 'Movie',
        components : {
            MovieCover : MovieCover,
            HorizontalScrollListCircular : HorizontalScrollListCircular,
            HorizontalScrollListRectangular : HorizontalScrollListRectangular,
            CommentsList : CommentsList,
            PostComment : PostComment,
            TwitterShareButton : TwitterShareButton,
            CommentButton : CommentButton,
            SupportButton : SupportButton,
            AgainstButton : AgainstButton
        },
        computed : {
            ...mapState(['userProfile', 'currentUser', 'comments', 'currentMovie'])
        },
        data : function () {
            return {
                movieInfo : {},
                coverImgBasePath: "https://image.tmdb.org/t/p/w500",
                castBasePath: "https://image.tmdb.org/t/p/w128_and_h128_face",
                movieCover : {
                    castingDirectors : '',
                    decision : '',
                    image : '',
                    nepometer : {},
                    ratings : '-',
                    subtitle : '',
                    title : '',
                    totalRatings : '',
                    loaded : false,
                },
                movieCastList : {
                    title : 'Cast',
                    list : []
                },
                similarMoviesList : {
                    title : 'Other Movies',
                    list : []
                },
                twitterShare : { network: 'twitter', name: 'Twitter', icon: ['fab', 'twitter'], color: '#ffffff', url: window.location.href, title: 'For rating Bollywood\'s rampant nepotism, visit', description: 'Nepometer: A platform to voice your views', quote: 'Swipe and raise your voice!', hashtags: 'nepotism,nepometer', twitterUser: 'Nepometer_IN'},
                buttonDisabled : false,
                movieDataDbUpload : {},
            }
        },
        methods : {
            fetchMovieData(){
                let key = process.env.VUE_APP_TMDB_APP_KEY;
                let movie_id = this.$route.params.movie_id;
                axios.get(`https://api.themoviedb.org/3/movie/${movie_id}?api_key=${key}`)
                .then((response) => {
                    this.movieDataDbUpload = Object.assign({}, response.data);
                    return axios.get(`https://api.themoviedb.org/3/movie/${movie_id}/credits?api_key=${key}`)
                })
                .then((response) => {
                    let data = Object.assign({}, response.data);
                    this.movieDataDbUpload['cast'] = data['cast'];
                    this.movieDataDbUpload['crew'] = data['crew'];
                    return fb.movieCollection.doc('' + movie_id).get()
                })
                .then((doc) => {
                    if (doc.exists) {
                        this.movieCover['nepometer'] = doc.data().nepometer;
                        return doc
                    } else {
                        this.movieCover['nepometer'] = {likes:0, nopes:0};
                        this.movieDataDbUpload['nepometer'] = {likes:0, nopes:0};
                        return fb.movieCollection.doc('' + movie_id).set(this.movieDataDbUpload)
                    }
                })
                .then((result) => {
                    this.prepareViewData();
                    this.fetchSimilarMovies();
                })
                .catch((err) => {
                    console.error(err.message);
                })
            },
            prepareViewData(){
                this.movieInfo = Object.assign({}, this.movieDataDbUpload);
                let bd = this.movieInfo.backdrop_path; 
                let image = this.coverImgBasePath
                if (bd == null) {
                    bd = this.movieInfo.poster_path;
                    if (bd == null) {
                        bd = '';
                        image = '';
                    }
                }
                this.movieCover['image'] = image + bd;
                this.movieCover['title'] = this.movieInfo.title;
                this.movieCover['subtitle'] = 'Nepotistic Rating';
                this.movieCover['castingDirectors'] = this.getCastingDirectors(this.movieInfo['crew']);
                this.movieCastList['list'] = this.getCast(this.movieInfo['cast']);
                this.movieCover['ratings'] = this.getNepometerRating(this.movieCover['nepometer']);
                this.movieCover['decision'] = this.setNepometerRating(this.movieCover['nepometer']);
                this.movieCover['totalRatings'] = this.getTotalRatings(this.movieCover['nepometer']);
                this.movieCover['loaded'] = true;
            },
            fetchSimilarMovies(){
                let checkGenreList = new Promise((resolve, reject) => {
                    let genreList = localStorage.getItem('genreList');
                    resolve(genreList);
                })
                checkGenreList
                .then((genreList) => {
                    if (genreList == null) {
                        return this.fetchCompleteGenreList().then((list) => {
                            localStorage.setItem('genreList', JSON.stringify(list));
                            return JSON.stringify(list);
                        });
                    } else {
                        return genreList;
                    }
                })
                .then((genreList) => {
                    let list = JSON.parse(genreList);
                    return list.sort((val1, val2) => {
                        return 0.5 - Math.random();
                    }).slice(0, 1);
                })
                .then((genreList) => {
                    let genres = genreList.join(',');
                    return axios.get(`https://api.themoviedb.org/3/discover/movie`, {
                        params : {
                            api_key : process.env.VUE_APP_TMDB_APP_KEY,
                            region : 'IN',
                            sort_by : 'popularity.desc',
                            include_adult : false,
                            include_video : false,
                            with_genres : genres,
                            with_original_language : 'hi'
                        }
                    });
                })
                .then((response) => {
                    let results = response.data.results;
                    let movie_id = this.movieDataDbUpload['id'];
                    return results.filter((e, i) => {
                        return e['id'] !== movie_id;
                    });
                })
                .then((results) => {
                    this.similarMoviesList['list'] = this.getSimilarMovies(results);
                })
                .catch((err) => {
                    console.log(err.message);
                })
            },
            fetchCompleteGenreList(){
                return axios.get(`https://api.themoviedb.org/3/genre/movie/list`, {
                    params : {
                        api_key : process.env.VUE_APP_TMDB_APP_KEY
                    }
                })
                .then((response) => {
                    let data = [...response.data.genres];
                    let genreList = [];
                    data.forEach((e, i) => {
                        genreList.push(e['id']);
                    });
                    return genreList;
                })
                .catch((err) => {
                    console.log(err.message);
                })
            },
            getNepometerRating(nepometer) {
                let total = Math.max(1,nepometer.likes + nepometer.nopes);
                let nepoPercentage = 10 * nepometer.likes / total;
                let nepoRating = Math.round(nepoPercentage*10)/10;
                return nepoRating;
            },
            getTotalRatings(nepometer) {
                let total = nepometer.likes + nepometer.nopes;
                let substr = (total>1)? 'ratings' : 'rating';
                return `${total} ${substr}`;
            },
            getCastingDirectors(list) {
                let names = [];
                for (let i = 0; i < list.length; i++) {
                    let item = list[i];
                    if (item['job'] === 'Director') {
                        names.push(item['name']);
                    }
                }
                return names.join(', ')
            },
            getCast(list) {
                let cast = [];
                for (let i = 0; i < list.length; i++) {
                    let element = list[i];
                    let pimg = element.profile_path
                    pimg = (pimg == null) ? '' : this.castBasePath + pimg;
                    cast.push({id:element.id, url:`/person/${element.id}`, title: element.name, image: pimg, subtitle: element.character})
                }
                return cast;
            },
            getSimilarMovies(list) {
                let similarMoviesList = [];
                list.forEach((e, i) => {
                    let item = {};
                    item['id'] = e['id'];
                    item['title'] = e['title'];
                    item['url'] = `/movie/${e.id}`
                    let bd = e['backdrop_path;'] 
                    let image = this.coverImgBasePath
                    if (bd == null) {
                        bd = e['poster_path'];
                        if (bd == null) {
                            bd = '';
                            image = '';
                        }
                    }
                    item['image'] = image + bd;
                    fb.movieCollection.doc('' + e['id']).get()
                    .then((doc) => {
                        if (doc.exists) {
                            item['nepometer'] = doc.data().nepometer;
                        } else {
                            item['nepometer'] = {likes:0, nopes:0};
                        }
                        item['ratings'] = this.getNepometerRating(item['nepometer']);
                        item['decision'] = this.setNepometerRating(item['nepometer']);
                        return doc;
                    })
                    .then((result) => {
                        similarMoviesList.push(item);
                    })
                });
                return similarMoviesList;
            },
            setNepometerRating(nepometer) {
                let total = Math.max(1, nepometer.likes + nepometer.nopes);
                let nepoPercentage = 10 * nepometer.likes / total;
                let nepoRating = Math.round(nepoPercentage*10)/10;
                return (nepoRating > 5) ? 'down' : 'up';
            },
            getCommentsTitle(){
                if (this.comments.list.length == 0) {
                    return 'Comments:'
                } else if(this.comments.list.length == 1) {
                    return 'Comment';
                } else {
                    return 'Comments';
                }
            },
            commentButtonClicked(){
                var commentsSectionPos = this.getOffset(document.querySelector('.comments-section'));
                window.scroll({
                    top : commentsSectionPos['top'],
                    behavior : 'smooth'
                })
            },
            getOffset(element) {
                let rect = element.getBoundingClientRect();
                let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
            },
            ratingSubmit(type){
                if (this.currentUser == null) {
                    this.$router.push('/login');
                    return;
                }
                this.buttonDisabled = true;
                let movie = Object.assign({}, this.movieInfo);
                let movieId = "" + movie.id;
                let ratingId = `${this.currentUser.uid}_${movieId}`;
                if (type == 'like') {
                    movie['nepometer'] = {"likes": 1, "nopes": 0};
                } else {
                    movie['nepometer'] = {"likes": 0, "nopes": 1};
                }
                fb.ratingCollection.doc(ratingId).get()
                .then((doc) => {
                    if (doc.exists) {
                        return doc;
                    } else {
                        return fb.ratingCollection.doc(ratingId).set({
                            userId : this.currentUser.uid,
                            movieId : movieId,
                            choice : type,
                        });
                    }
                })
                .then((result) => {
                    return fb.movieCollection.doc(movieId).get();
                })
                .then((doc) => {
                    if (doc.exists) {
                        if (type == 'like') {
                            return fb.movieCollection.doc(movieId).update({"nepometer.likes": increment});
                        } else {
                            return fb.movieCollection.doc(movieId).update({"nepometer.nopes": increment});
                        }
                    } else {
                       return fb.movieCollection.doc(movieId).set(movie);
                    }
                })
                .then((result) => {
                })
                .catch((err) => {
                    this.buttonDisabled = false;
                    console.error(err.message);
                })
            }
        },
        created() {
            /* this.fetchMovieInfo();
            this.fetchMovieCast(); */
            this.fetchMovieData();
        },
        mounted(){
            this.$store.dispatch('updateCurrentMovie', { id : this.$route.params.movie_id });
            this.$store.dispatch('fetchMovieComments', { id : this.$route.params.movie_id });
        }
    }
</script>

<style>
    .movie-cover-img{
        height: 400px;
        background-size: cover;
        background-position: center;
    }
    .movie-cover-img .tint-section{
        background: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, #000000 100%);
    }
    .bottom-tray.movie-page{
        background: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, #000000 100%);
    }
    .pd-b-160{
        padding-bottom: 160px;
    }
    .movie-page .comments-list-section .comments-status{
        padding-top: 80px;
        padding-bottom: 60px;
    }
</style>